export const environment = {
  production: true,
  AUTH0_DOMAIN: 'speedline.eu.auth0.com',
  AUTH0_CLIENT_ID_WEB: 'W8P1GExauD6B3bUsWmZ2iwBL0cD8Yc1M',
  AUTH0_CLIENT_ID_NATIVE: 'YRRNoxTY61a6Ca9eXonrYPUdHCKW7PoZ',
  BUNDLE_ID: 'it.speedline.clientapp',
  API_URL: 'https://speedlinebackend.siwego.com',
  ONE_SIGNAL_APP_ID: '55149f50-4f32-4712-a9c5-24443896694f',
  ONE_SIGNAL_PROJECT_NUMBER: '',
  MIN_TRAVEL_PRICE: 3,
  APP_NAME: 'Speedline',
  LOCATION_FREQUENCY: 10, // in minutes
  LEMONWAY_RETURN_URL: 'https://speedline.siwego.com/redirects/thankyou',
  LEMONWAY_SUBSCRIPTION_RETURN_URL: 'https://speedline.siwego.com/redirects/thankyou-subscription',
  LEMONWAY_CANCEL_URL: 'https://speedline.siwego.com/redirects/payment-cancel',
  LEMONWAY_ERROR_URL: 'https://speedline.siwego.com/redirects/payment-error',

  STRIPE_RETURN_URL: 'https://speedline.siwego.com/thankyou',
  STRIPE_SUBSCRIPTION_RETURN_URL: 'https://speedline.siwego.com/thankyou-subscription',
  STRIPE_CANCEL_URL: 'https://speedline.siwego.com/payment-cancel',
  STRIPE_ERROR_URL: 'https://speedline.siwego.com/payment-error',
  
  SHOW_STACK_ERROR: true,
  SUPPORT_EMAIL: 'support@speedlinetrasporti.com',
  PAY_NOW_CARRIER_PROFILE_ID: 135
};
